import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FunctionsService } from "../services/functions.service";
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConstants } from '../app.constants';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css', '../login/login.component.css'],
    providers: [NgxSpinnerService]
})

export class ForgotPasswordComponent implements OnInit {
    email:string;
    forgotPasswordForm = new UntypedFormGroup({
        Email: new UntypedFormControl('', Validators.compose([
            Validators.required,
            Validators.pattern(AppConstants.emailRegex)
        ]))
    });

    tempPasswordForm = new UntypedFormGroup({
        Password: new UntypedFormControl('', Validators.compose([
            Validators.required
        ]))
    });

    constructor(
        private apiService: ApiService,
        public functionsService: FunctionsService,
        private router: Router,
        private spinner: NgxSpinnerService,
        private translate: TranslateService
    ) {
        translate.setDefaultLang('en');
        this.functionsService.setTitle('password.forgot_pass');
    }

    formSubmitted: boolean = false;
    formSubmittedVC: boolean = false;
    language = localStorage.getItem('language')?localStorage.getItem('language'):'en';

    ngOnInit(){
        document.getElementById("forgotEmailError").innerHTML = "";
        document.getElementById("forgotEmailSent").hidden = true;
        document.getElementById("forgotPass").hidden = false;

        if(localStorage.getItem('language') != null){
            this.functionsService.useLanguage(localStorage.getItem('language'));
        }
    }

    get Email() { return this.controlGetterFP('Email'); }
    get Password() { return this.controlGetterVC('Password'); }

    forgotPassword() {
        //Do not perform an action if email is invalid
        if (!this.forgotPasswordForm.valid) {
            this.formSubmitted = true;
            return;
        } 
        this.spinner.show();
        document.getElementById("forgotEmailError").innerHTML = "";
        
        //Call API service
        this.apiService.forgotPassword(this.forgotPasswordForm.value).subscribe(
            () => {
                document.getElementById("forgotPass").hidden = true;
                document.getElementById("forgotEmailSent").hidden = false;
                this.email = this.forgotPasswordForm.value["Email"];
                this.spinner.hide();
            },
            error => {
                this.spinner.hide();
                if(error["error"] && (error["error"] == "subscription_expired" || error["error"] == "new_user_error")) {
                    document.getElementById("forgotEmailError").innerText = this.translate.instant("password.error");
                    document.getElementById("Email").classList.add('is-invalid');
                    this.translate.onLangChange.subscribe(() => {
                        if(error["error"] && (error["error"] == "subscription_expired" || error["error"] == "new_user_error")) {
                            document.getElementById("forgotEmailError").innerText = this.translate.instant("password.error");
                            document.getElementById("Email").classList.add('is-invalid')
                        }
                    });
                
                }
                else {
                    this.functionsService.errorHandler(error["status"]);
                }
            }
        )
    }

    tempPassword(){
        document.getElementById("invalidTempPass").hidden = true;
        //Do not perform an action if email is invalid
        if (!this.tempPasswordForm.valid) {
            this.formSubmittedVC = true;
            return;
        } 
        this.tempPasswordForm.value["Email"] = this.email;
        this.apiService.verifyTempPass(this.tempPasswordForm.value).subscribe(
            data => {
                //Go to the reset password page;
                this.router.navigateByUrl('/resetPassword?value='+data["token"]);
            },
            error => {
                if(localStorage.getItem('language') != null){
                    this.functionsService.useLanguage(localStorage.getItem('language'));
                }
                if (error["status"] == 404) {
                    document.getElementById("invalidTempPass").hidden = false;
                    document.getElementById("invalidTempPass").innerText = this.translate.instant(error.error["content"]);
                    this.translate.onLangChange.subscribe(() => {
                        if (error["status"] == 404) {
                            document.getElementById("invalidTempPass").innerText = this.translate.instant(error.error["content"]);
                        }
                    });
                } else
                    this.functionsService.errorHandler(error["status"]);
            }
        )
    }

    controlGetterFP(controlName) {
        const control = this.forgotPasswordForm.get(controlName);
        return control && (control.touched || this.formSubmitted) ? control : {};
    }

    controlGetterVC(controlName) {
        const control = this.tempPasswordForm.get(controlName);
        return control && (control.touched || this.formSubmittedVC) ? control : {};
    }

    clearErrorMessage() {

        if(document.getElementById('forgotEmailError'))
            document.getElementById("forgotEmailError").innerHTML = ""

            document.getElementById("invalidTempPass").hidden = true;
    document.getElementById('Email')?.classList.remove('is-invalid')
    }
}